import React from 'react';
import { Reservation, Accommodation } from '../types';

interface TimelineProps {
  reservations: Reservation[];
  accommodations: Accommodation[];
}

export default function ReservationsTimeline({ reservations, accommodations }: TimelineProps) {
  const daysInMonth = Array.from({ length: 30 }, (_, i) => i + 1); // Simplification

  return (
    <div className="bg-white border border-zinc-200 rounded-xl shadow-sm p-4 overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr>
            <th className="p-2 border-b">Acomodação</th>
            {daysInMonth.map(day => (
              <th key={day} className="p-2 border-b w-8">{day}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {accommodations.filter(a => a.active).map(acc => (
            <tr key={acc.id}>
              <td className="p-2 border-b font-medium">{acc.name}</td>
              {daysInMonth.map(day => {
                const date = `2026-06-${String(day).padStart(2, '0')}`;
                const reservation = reservations.find(r => 
                    r.accommodationId === acc.id && 
                    date >= r.checkInDate && 
                    date < r.checkOutDate &&
                    r.status !== 'Cancelado'
                );
                
                return (
                  <td key={day} className={`p-1 border-b ${reservation ? 'bg-indigo-500' : 'bg-zinc-50'}`}>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
